import { gql } from '@apollo/client';

export const MyNotifications = gql`
  query MyNotifications($limit: Int, $cursor: Int) {
    myNotifications(limit: $limit, cursor: $cursor) {
      id
      title
      message
      hasBeenRead
      createdAt
    }
  }
`;

export const MyUnreadNotificationsCount = gql`
  query MyUnreadNotificationsCount {
    myUnreadNotificationsCount
  }
`;
